import ApiClient from "../ApiClient";

const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
  timeZone: "UTC",
});

function normalizeIntentLeadValue(value) {
  if (value == null || value === "") return "-";
  return value;
}

function formatIntentLeadDate(value) {
  if (!value || value === "-") return "-";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return dateFormatter.format(date);
}

function normalizeIntentLead(lead, index = 0) {
  const intentLeadId = lead?.intentLeadId ?? lead?.IntentLeadId ?? lead?.id ?? lead?.Id;

  return {
    rowKey: intentLeadId ?? `intent-lead-${index + 1}`,
    intentLeadId,
    name: normalizeIntentLeadValue(lead?.name ?? lead?.Name),
    companyName: normalizeIntentLeadValue(
      lead?.companyName ?? lead?.CompanyName ?? lead?.company ?? lead?.Company,
    ),
    domain: normalizeIntentLeadValue(lead?.domain ?? lead?.Domain),
    industry: normalizeIntentLeadValue(lead?.industry ?? lead?.Industry),
    location: normalizeIntentLeadValue(lead?.location ?? lead?.Location),
    intentScore: normalizeIntentLeadValue(lead?.intentScore ?? lead?.IntentScore),
    email: normalizeIntentLeadValue(lead?.email ?? lead?.Email),
    designation: normalizeIntentLeadValue(lead?.designation ?? lead?.Designation),
    aiSummary: normalizeIntentLeadValue(lead?.aiSummary ?? lead?.AiSummary),
    createdOn: formatIntentLeadDate(lead?.createdOn ?? lead?.CreatedOn),
    raw: lead,
  };
}

function normalizeTopIntentLeadsResponse(response) {
  const payload = response?.data?.data ?? response?.data ?? {};
  const intentLeadItems =
    payload?.leads ??
    payload?.Leads ??
    payload?.leadDetails ??
    payload?.items ??
    payload?.records ??
    payload?.data ??
    [];

  return {
    totalLeads: payload?.totalLeads ?? payload?.TotalLeads ?? intentLeadItems.length ?? 0,
    data: Array.isArray(intentLeadItems)
      ? intentLeadItems.map((lead, index) => normalizeIntentLead(lead, index))
      : [],
  };
}

const IntentLeadService = {
  async getTopIntentLeads(count = 5) {
    const response = await ApiClient.get(`/IntentLead/top-lead`, {
      params: { count },
    });

    return normalizeTopIntentLeadsResponse(response);
  },

  async convertIntentLead(intentLeadId) {
    return ApiClient.post(`/IntentLead/convert-intent-lead`, {
      intentLeadId,
    });
  },
};

export default IntentLeadService;
